module.exports = __webpack_public_path__ + "img/engraving-1@2x.ee8ae66.png";